import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

export const demandDocumentFormDataSchema = z.object({
  files: z.array(
    z.object({
      fileId: z.string(),
      isSharedWithSupplier: z.boolean(),
      isDeleted: z.boolean(),
      hasNegotiationCase: z.boolean(),
    }),
  ),
});

export type DemandDocumentFormData = z.infer<typeof demandDocumentFormDataSchema>;

export const demandDocumentFormDataDefault: DefaultValues<DemandDocumentFormData> = {
  files: [],
};
